var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M15.928 12.76c3.015 0 5.422 2.617 5.532 5.84l.004.23v1.258c0 .536-.406.976-.929 1.033l-.113.006H3.572c-.537 0-.98-.405-1.036-.926l-.006-.113V18.83c0-3.25 2.337-5.942 5.321-6.065l.215-.005h7.862zm0 1.8H8.066c-1.971 0-3.632 1.768-3.731 4.055l-.005.215-.001.496h15.335v-.496c0-2.317-1.601-4.155-3.552-4.264l-.183-.006zM11.998 1.6c2.696 0 4.879 2.195 4.879 4.897 0 2.703-2.183 4.898-4.88 4.898S7.117 9.2 7.117 6.497c0-2.702 2.183-4.897 4.88-4.897zm0 1.8c-1.7 0-3.08 1.386-3.08 3.097 0 1.712 1.38 3.098 3.08 3.098 1.699 0 3.079-1.386 3.079-3.098 0-1.711-1.38-3.097-3.08-3.097z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.222ed704ca1b55c1dbed807a24059ed7.svg";
export { ForwardRef as ReactComponent };